import { isEmpty } from 'lodash';
import React, { ReactElement } from 'react';
import { handleScrollToSection } from '../../../utils/reportingUtility';
import RefreshInfoCard from '../reportingUtils/RefreshInfoCard';
import { REPORTING_CONSTANTS } from '../reportingUtils/reportingAndAnalyticsConstants';
import TransactionReportModal from '../reportingUtils/TransactionReportModals';
interface MetricNavSidebarProps {
  sections: any;
  activeSection: string;
  configuredPayers: any;
  availableStatus: any;
  refreshedInfo: any;
}

const TransactionCountNavigation: React.FC<MetricNavSidebarProps> = (
  props: any,
): ReactElement => {
  const {
    sections,
    activeSection,
    configuredPayers,
    availableStatus,
    refreshedInfo,
  } = props;

  return (
    <div className="metric-nav-sidebar">
      <TransactionReportModal
        configuredPayers={configuredPayers}
        availableStatus={availableStatus}
        refreshedInfo={refreshedInfo}
      />
      {!isEmpty(refreshedInfo) && (
        <>
          {sections?.map(
            ({ key, label }: any): ReactElement => (
              <div
                key={key}
                className={`nav-item ${activeSection === key ? 'active' : ''}`}
                onClick={(): void => handleScrollToSection(key)}
              >
                {label}
              </div>
            ),
          )}
        </>
      )}

      <RefreshInfoCard
        dataAvailableFrom={refreshedInfo?.dataAvailableFrom}
        lastRefreshedOn={refreshedInfo?.lastRefreshedOn}
        refreshFrequency={
          refreshedInfo?.dataRefreshedOn ?? REPORTING_CONSTANTS.EVERY_15_MINUTES
        }
      />
    </div>
  );
};

export default TransactionCountNavigation;
